import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useAppContext } from 'src/appState';

import type { NextPage } from 'next';

const HomePage: NextPage = () => {
    const router = useRouter();
    const { t } = useTranslation('restaurantAdmin.index');
    const { auth } = useAppContext();

    return (
        <Container maxWidth="sm">
            <Box sx={{ pb: '2rem' }}>
                <img alt="Qerko Logo" src={`${router.basePath}/qerko-logo.svg`} />
            </Box>
            <Box alignItems="center" display="flex" flexDirection="column" justifyContent="center">
                <Typography align="center" variant="h3">{t('page.title.welcome')}</Typography>
                <Typography align="center" variant="h6">{t('page.title.noAccess', { email: (auth && auth.user.email ? auth.user.email : '') })}</Typography>
                <Typography align="center" variant="h6">{t('page.title.contactQerko')}</Typography>
                <Typography align="center" variant="h6">{t('page.title.findContactDetails')}<a href="https://qerko.com/kontakt" rel="noreferrer" target="_blank">{t('page.title.contactPage')}</a></Typography>
            </Box>
        </Container>
    );
};

export default HomePage;
